export const config = {
  state: {
    lang: "EN",
    mode: "light",
  },
  reducers: {
    toggleMode(state) {
      if (state.mode === "light") {
        return { ...state, mode: "dark" };
      }
      return { ...state, mode: "light" };
    },
    changeLang(state, _lang) {
      return { ...state, lang: _lang };
    },
  },
  effects: (dispatch) => ({
    async testAsync(payload, rootState) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch.count.increment(payload);
    },
  }),
};
